import { Children } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import classNames from "classnames/bind";
import {
    Navigation,
    Keyboard,
    Mousewheel,
    A11y,
    FreeMode,
    EffectFade,
} from "swiper/modules";
import "swiper/scss";
import "swiper/scss/free-mode";
import "swiper/scss/navigation";
import "swiper/scss/a11y";
import "swiper/scss/keyboard";
import "swiper/scss/mousewheel";

import { SliderProps } from "./interface";
import "./swiperOverrides.scss";
import classes from "./slider.module.scss";

const Slider = ({
    children,
    numSlides,
    customControls,
    centered,
    freemode,
    a11yName,
    a11yRole,
    initialSlide,
    onSlideChange = () => null,
    onSwiper = () => null,
}: SliderProps) => {
    const cx = classNames.bind(classes);

    const renderSlides = () => {
        const slideClasses = cx(
            "slide",
            { centered: centered },
            { freemode: freemode }
        );

        return Children.map(children, (child, index) => {
            return (
                <SwiperSlide key={index} className={slideClasses}>
                    {child}
                </SwiperSlide>
            );
        });
    };

    const hasCustomControls =
        customControls &&
        customControls?.leftButtonRef.current !== null &&
        customControls?.rightButtonRef.current !== null;

    return (
        <Swiper
            slidesPerView={numSlides ? numSlides : "auto"}
            slidesPerGroupAuto={true}
            spaceBetween={16}
            freeMode={{ sticky: freemode && true, enabled: freemode }}
            centeredSlides={centered}
            effect={"slide"}
            updateOnWindowResize={true}
            onSlideChange={onSlideChange}
            onSwiper={onSwiper}
            initialSlide={initialSlide}
            navigation={
                hasCustomControls && {
                    enabled: true,
                    nextEl: customControls.rightButtonRef?.current,
                    prevEl: customControls.leftButtonRef?.current,
                }
            }
            mousewheel={{
                forceToAxis: true,
            }}
            keyboard={true}
            a11y={{
                enabled: true,
                containerRole: a11yRole,
                containerMessage: a11yName,
            }}
            modules={[
                FreeMode,
                Navigation,
                A11y,
                Keyboard,
                Mousewheel,
                EffectFade,
            ]}
            className={classes.swiper}
        >
            {renderSlides()}
        </Swiper>
    );
};

export default Slider;
